import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Container,
  Heading,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  VStack,
  useToast,
  Spinner,
  Badge,
  HStack,
  Icon,
  Stack,
  Tag,
  Button,
  useDisclosure
} from "@chakra-ui/react";
import { MdEventNote, MdAttachMoney, MdDiscount, MdMoneyOff } from "react-icons/md";
import PaymentModal from "./Modal";
import { BASE_URL } from "../../../../../Globalapi/Globalapi";
const Fees = () => {
  const [feesData, setFeesData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const toast = useToast();
  const [selectedFee, setSelectedFee] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const studentId = sessionStorage.getItem("student_id");

    axios
      .post(
        `${BASE_URL}/admin/Fees/fees_master/assigned_fees.php`,
        {
          student_id: studentId,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.success) {
          setFeesData(response.data.data);
          console.log('====================================');
          console.log(response.data.data);
          console.log('====================================');
        } else {
          setError(response.data.message);
          toast({
            title: "Error",
            description: response.data.message,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      })
      .catch(() => {
        setLoading(false);
        setError("Error fetching data. Please try again.");
        toast({
          title: "Error",
          description: "Error fetching data. Please try again.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  }, [toast]);

  if (loading) return <Spinner size="xl" mt="20" />;

  const handlePayment = (amount) => {
    console.log(`Paid ${amount} for fee: ${selectedFee.fee_name}`);
    // Additional logic to process the payment (e.g., API call)
  };
  return (
    <Container maxW="full">
      {error && (
        <Box
          mb={6}
          p={4}
          bgColor="red.100"
          borderRadius="md"
          color="red.600"
          textAlign="center"
        >
          {error}
        </Box>
      )}

      {feesData && feesData.length > 0 ? (
        <HStack spacing={6} wrap="wrap" align="stretch" justify="space-between">
          {feesData.reduce((rows, fee, index) => {
            // Create rows of two items
            if (index % 2 === 0) {
              rows.push([fee]);
            } else {
              rows[rows.length - 1].push(fee);
            }
            return rows;
          }, []).map((row, rowIndex) => (
            <HStack spacing={6} key={rowIndex} width="100%" justify="space-around">
              {row.map((fee) => (
                <Box
                  key={fee.fee_master_id}
                  p={4}
                  height='100%'
                  bg="white"
                  borderRadius="xl"
                  boxShadow="sm"
                  _hover={{
                    transform: "scale(1.02)",
                    boxShadow: "md",
                  }}
                  transition="all 0.2s ease-in-out"
                  borderWidth={1}
                  flex="1"
                >
                  <VStack spacing={4} align="start">
                    <HStack justify="space-between" width="100%">
                      <Heading as="h3" size="md" color="teal.500">
                        {fee.fee_name}
                      </Heading>
                      <Button
                        size="sm"
                        colorScheme="teal"
                        onClick={() => {
                          setSelectedFee(fee);
                          onOpen();
                        }}
                      >
                        Pay
                      </Button>
                    </HStack>
                    <HStack justify="space-between" width="100%">
                      <Text fontSize="sm" color="gray.600">
                        {fee.fee_group_name}
                      </Text>
                    </HStack>
                    <Stack spacing={3} direction="row" w="full" justify="center">
                      {/* Due Date */}
                      <Box
                        flex={1}
                        p={3}
                        borderRadius="md"
                        bg="cyan.50"
                        textAlign="center"
                        shadow="sm"
                      >
                        <Icon as={MdEventNote} boxSize={5} mb={1} color="cyan.600" />
                        <Text fontWeight="medium" fontSize="sm">
                          Due Date
                        </Text>
                        <Text fontSize="xs">{fee.due_date}</Text>
                      </Box>
                      {/* Payment Status */}
                      <Box
                        flex={1}
                        p={3}
                        borderRadius="md"
                        bg={fee.payment_status === "paid" ? "green.50" : "red.50"}
                        textAlign="center"
                        shadow="sm"
                      >
                        <Icon
                          as={MdAttachMoney}
                          boxSize={5}
                          mb={1}
                          color={
                            fee.payment_status === "paid" ? "green.600" : "red.600"
                          }
                        />
                        <Text fontWeight="medium" fontSize="sm">
                          Status
                        </Text>
                        <Badge
                          colorScheme={
                            fee.payment_status === "paid" ? "green" : "red"
                          }
                          fontSize="sm"
                        >
                          {fee.payment_status}
                        </Badge>
                      </Box>
                      {/* Discount */}
                      <Box
                        flex={1}
                        p={3}
                        borderRadius="md"
                        bg="purple.50"
                        textAlign="center"
                        shadow="sm"
                      >
                        <Icon
                          as={MdDiscount}
                          boxSize={5}
                          mb={1}
                          color="purple.600"
                        />
                        <Text fontWeight="medium" fontSize="sm">
                          Amount
                        </Text>
                        <Text fontSize="xs">{fee.t_total}</Text>
                      </Box>
                      {/* Fine Amount */}
                      <Box
                        flex={1}
                        p={3}
                        borderRadius="md"
                        bg="red.100"
                        textAlign="center"
                        shadow="sm"
                      >
                        <Icon
                          as={MdMoneyOff}
                          boxSize={5}
                          mb={1}
                          color="blue.600"
                        />
                        <Text fontWeight="medium" fontSize="sm">
                          Fine Amount
                        </Text>
                        <Text fontSize="xs">{fee.fine_amount}</Text>
                      </Box>
                    </Stack>
                    {/* Fee Table */}
                    <TableContainer width="100%">
                      <Table
                       sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}
                        size="md"
                        bg="white"
                        borderRadius="md"
                        boxShadow="lg"
                      >
                        <Thead bg="gray.100">
                          <Tr>
                            <Th color="teal.700">Fee Type</Th>
                            <Th isNumeric color="teal.700">
                              Amount
                            </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {fee.fee_amounts.map((amountData, index) => (
                            <Tr
                              key={index}
                              _hover={{
                                bg: "gray.50",
                                cursor: "pointer",
                              }}
                            >
                              <Td>{amountData.fee_type_name}</Td>
                              <Td isNumeric>{amountData.amount}</Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </VStack>
                </Box>
              ))}
            </HStack>
          ))}
        </HStack>

      ) : (
        <Text fontSize="lg" color="red.600" textAlign="center">
          No fees available.
        </Text>
      )}
      <PaymentModal
        isOpen={isOpen}
        onClose={onClose}
        feeName={selectedFee ? selectedFee.fee_name : ""}
        amount={selectedFee ? selectedFee.total_amount : ""}
        last={selectedFee ? selectedFee.due_date : ""}
        feeMasterId={selectedFee ? selectedFee.fee_master_id : ""}
        status={selectedFee ? selectedFee.payment_status : ""}
        studentledid={selectedFee ? selectedFee.std_led_id : ""}
        onPay={handlePayment}
      />
    </Container>
  );
};

export default Fees;
